import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const storage = JSON.parse(localStorage.getItem('diabotical/leaderboards')) || {}

function save(props = {}) {
  for (const key in props) {
    storage[key] = props[key]
  }
  localStorage.setItem('diabotical/leaderboards', JSON.stringify(storage))
}

function getPlacementsById(players) {
  const placements = {}
  for (const mode of store.getters.modes) {
    placements[mode.id] = {}
    const modePlayers = players.filter(player => player[mode.id])
    modePlayers.sort((player1, player2) => {
      return player1[mode.id].rating > player2[mode.id].rating ? -1 : 1
    })
    for (let index = 0; index < modePlayers.length; index++) {
      placements[mode.id][modePlayers[index].id] = index + 1
    }
  }
  return placements
}

// const modes = [
//   // { id: 'md_duel', name: 'Duel', title: 'Duel' },
//   // { id: 'md_wipeout', name: 'Wipeout', title: 'Wipeout' },
//   // { id: 'md_arena_solo', name: 'Aim Arena', title: 'Aim Arena' },
//   { id: 'r_duel', newId: 'md_duel', name: 'Duel', title: '1v1 Duel' },
//   { id: 'r_wo', newId: 'md_wipeout', name: 'Wipeout', title: '4v4 Wipeout' },
//   { id: 'r_ca_1', newId: 'md_arena_solo', name: 'Aim Solo', title: '1v1 Aim Arena' },
//   { id: 'r_ca_2', newId: 'md_arena_team', name: 'Aim Team', title: '2v2 Aim Arena' },
//   // { id: 'r_team', name: '3v3 Circuit', title: '3v3 Circuit' },
//   { id: 'r_ext_3', name: 'Extinction', title: '3v3 Extinction' },
//   { id: 'r_shaft_arena_1', name: 'Shaft', title: '1v1 Shaft Arena' },
//   { id: 'r_rocket_arena_2', name: 'Rocket', title: '2v2 Rocket Arena' },
//   { id: 'r_macguffin', name: 'MacGuffin', title: '4v4 MacGuffin' },
// ]

const store = new Vuex.Store({
  state: {
    date: 'latest',
    dates: [],
    dropdown: false,
    filter: {
      name: '',
    },
    loading: 0,
    players: [],
    test: storage.test || false,
    sort: storage.sort || '',
    sticked: storage.sticked || [],
    weapons: [
      { id: 'gun:0', index: 0, name: 'Melee' },
      { id: 'gun:1', index: 1, name: 'Machine Gun' },
      { id: 'gun:2', index: 2, name: 'Blaster' },
      { id: 'gun:3', index: 3, name: 'Super Shotgun' },
      { id: 'gun:4', index: 4, name: 'Rocket Launcher' },
      { id: 'gun:5', index: 5, name: 'Shaft' },
      // { id: 'gun:6', index: 6, name: 'Crossbow' },
      { id: 'gun:7', index: 6, name: 'PnCR' },
      // { id: 'gun:8', index: 7, name: 'Grenade Launcher' },
      { id: 'gun:19', index: 8, name: 'Void Cannon' },
    ],
    loadedStats: {},
    shownStats: [],
    hoveredMode: 'all',
    modalCountries: location.hash === '#countries',
  },
  getters: {
    modes(state) {
      if (state.date < '2020-12-30') {
        return [
          // { id: 'md_duel', name: 'Duel', title: 'Duel' },
          // { id: 'md_wipeout', name: 'Wipeout', title: 'Wipeout' },
          // { id: 'md_arena_solo', name: 'Aim Arena', title: 'Aim Arena' },
          { id: 'r_duel', newId: 'md_duel', name: 'Duel', title: '1v1 Duel' },
          { id: 'r_wo', newId: 'md_wipeout', name: 'Wipeout', title: '4v4 Wipeout' },
          { id: 'r_ca_1', newId: 'md_arena_solo', name: 'Aim Solo', title: '1v1 Aim Arena' },
          { id: 'r_ca_2', newId: 'md_arena_team', name: 'Aim Team', title: '2v2 Aim Arena' },
          // { id: 'r_team', name: '3v3 Circuit', title: '3v3 Circuit' },
          { id: 'r_ext_3', name: 'Extinction', title: '3v3 Extinction' },
          { id: 'r_shaft_arena_1', name: 'Shaft', title: '1v1 Shaft Arena' },
          { id: 'r_rocket_arena_2', name: 'Rocket', title: '2v2 Rocket Arena' },
          { id: 'r_macguffin', name: 'MacGuffin', title: '4v4 MacGuffin' },
        ]
      }
      if (state.date < '2021-02-01') {
        return [
          { id: 'md_duel', newId: 'md_duel', name: 'Duel', title: 'Duel' },
          { id: 'md_tdm_small', newId: 'md_tdm_small', name: 'TDM', title: 'TDM, TDM Classic' },
          { id: 'md_arena_solo', newId: 'md_arena_solo', name: 'Arena Duel', title: 'Arena Duel' },
          { id: 'md_arena_team', newId: 'md_arena_team', name: 'Arena Team', title: 'Wipeout, Aim Arena, Aim Arena Classic' },
          { id: 'r_macguffin', name: 'MacGuffin', title: '4v4 MacGuffin' },
          { id: 'r_ext_3', name: 'Extinction', title: '3v3 Extinction' },
          { id: 'md_ffa', newId: 'md_ffa', name: 'FFA', title: 'Brawl, FFA' },
          // { id: 'r_shaft_arena_1', name: 'Shaft', title: '1v1 Shaft Arena' },
          // { id: 'r_rocket_arena_2', name: 'Rocket', title: '2v2 Rocket Arena' },
        ]
      }
      return [
        { id: 'md_duel', newId: 'md_duel', name: 'Duel', title: 'Duel' },
        { id: 'md_tdm_small', newId: 'md_tdm_small', name: 'TDM', title: 'TDM, TDM Classic' },
        { id: 'md_wipeout', newId: 'md_wipeout', name: 'Wipeout', title: 'Wipeout' },
        { id: 'md_arena_solo', newId: 'md_arena_solo', name: 'Arena Duel', title: 'Arena Duel' },
        { id: 'md_arena_team', newId: 'md_arena_team', name: 'Arena Team', title: 'Aim Arena, Aim Arena Classic' },
        { id: 'r_macguffin', name: 'MacGuffin', title: '4v4 MacGuffin' },
        { id: 'r_ext_3', name: 'Extinction', title: '3v3 Extinction' },
        // { id: 'md_ffa', newId: 'md_ffa', name: 'FFA', title: 'Brawl, FFA' },
      ]
    },
    sort(state, getters) {
      return state.sort && getters.modes.find(mode => state.sort.includes(mode.id)) ? state.sort : state.date < '2020-12-30' ? 'r_duel.rating' : 'md_duel.rating'
    },
    sortMode(state, getters) {
      return getters.sort.split('.')[0]
    },
    sortField(state, getters) {
      return getters.sort.split('.')[1]
    },
    sortedPlayers(state, getters) {
      const [mode, field] = getters.sort.split('.')
      const players = state.players.concat()
      const placements = getPlacementsById(players)

      players.sort((player1, player2) => {
        const value1 = (player1[mode] && player1[mode][field]) || 0
        const value2 = (player2[mode] && player2[mode][field]) || 0
        return value1 > value2 ? -1 : 1
      })

      for (const player of players) {
        for (const mode of getters.modes) {
          if (player[mode.id]) {
            player[mode.id].placement = placements[mode.id][player.id]
            if (player[mode.id].rating > 2210) {
              if (player[mode.id].placement === 1) {
                player[mode.id].tier = 44
              } else if (player[mode.id].placement < 50) {
                player[mode.id].tier = 43
              } else if (player[mode.id].placement < 100) {
                player[mode.id].tier = 42
              } else {
                player[mode.id].tier = 41
              }
            }
          }
        }
      }

      return players
    },
    countries(state, getters) {
      const dataByCountry = {}
      const playersByCountry = {}
      const minRatings = {}
      for (const mode of getters.modes) {
        const data = {}
        for (const player of getters.sortedPlayers) {
          if (player[mode.id] && (!minRatings[mode.id] || minRatings[mode.id] > player[mode.id].rating)) {
            minRatings[mode.id] = player[mode.id].rating
          }
        }
        for (const player of getters.sortedPlayers) {
          const country = player.country
          if (country && player[mode.id]) {
            data[country] = data[country] || { players: 0, placement: 0, totalPlacement: 0, rating: 0, totalRating: 0, matches: 0, wins: 0 }
            data[country].players += 1
            data[country].placement += 501 - player[mode.id].placement
            data[country].totalPlacement += player[mode.id].placement
            data[country].rating += player[mode.id].rating - minRatings[mode.id] + 1
            data[country].totalRating += player[mode.id].rating
            data[country].matches += player[mode.id].matches
            data[country].wins += player[mode.id].wins
            data[country].winrate = Math.round((100 * data[country].wins) / data[country].matches)
            data[country].avgMatches = Math.round(data[country].matches / data[country].players)
            data[country].avgRating = Math.round(data[country].totalRating / data[country].players)
            data[country].avgPlacement = Math.round(data[country].totalPlacement / data[country].players)
            playersByCountry[country] = playersByCountry[country] ? playersByCountry[country].concat(player) : [player]
          }
        }
        dataByCountry[mode.id] = data
      }
      return Object.keys(playersByCountry).map(countryName => {
        const country = { name: countryName, players: playersByCountry[countryName] }
        for (const mode of getters.modes) {
          country[mode.id] = dataByCountry[mode.id][countryName]
        }
        return country
      })
    },
    filteredPlayers(state, getters) {
      return getters.sortedPlayers.filter(player => {
        const matchName = player.name.toLowerCase().includes(state.filter.name.toLowerCase())
        return matchName
      })
    },
    stickedPlayers(state, getters) {
      return getters.sortedPlayers.filter(player => state.sticked.includes(player.id))
    },
  },
  mutations: {
    update(state, props) {
      for (const key in props) {
        state[key] = props[key]
      }
    },
    addLoading(state) {
      state.loading += 1
    },
    removeLoading(state) {
      state.loading -= 1
    },
    toggleStats(state, userId) {
      const index = state.shownStats.indexOf(userId)
      if (index === -1) {
        state.shownStats.push(userId)
      } else {
        state.shownStats.splice(index, 1)
      }
    },
  },
  actions: {
    update({ commit }, props) {
      commit('update', props)
    },
    toggleDropdown({ state, commit }, dropdown = !state.dropdown) {
      commit('update', { dropdown })
    },
    updateFilter({ state, commit }, newFilter) {
      const filter = { ...state.filter }
      for (const key in filter) {
        filter[key] = newFilter[key]
      }
      commit('update', { filter })
    },
    fetchDates({ commit }) {
      commit('addLoading')
      return fetch(`data/dates.json`)
        .then(res => res.json())
        .then(dates => {
          dates = dates.slice(-6)
          dates.unshift('2020-12-29T00:01:57.905Z')
          commit('update', { dates })
        })
        .catch(() => {
          console.warn(`Can't load available dates`)
        })
        .finally(() => {
          commit('removeLoading')
        })
    },
    fetchData({ commit }, date) {
      const day = date ? new Date(date).toISOString().substr(0, 10) : 'latest'
      commit('addLoading')
      return fetch(`data/${day}.json`)
        .then(res => res.json())
        .catch(() => {
          console.warn(`Can't load data of ${day}`)
        })
        .finally(() => {
          commit('removeLoading')
        })
    },
    updateData({ getters, dispatch, commit }, date) {
      return dispatch('fetchData', date)
        .then(data => {
          for (const player of data.players) {
            for (const mode of getters.modes) {
              if (player[mode.id]) {
                player[mode.id].placementDiff = 0
                player[mode.id].ratingDiff = 0
              }
            }
          }
          commit('update', data)
          dispatch('updateDiffs')
        })
        .catch(err => {
          console.warn('Something went wrong', err)
        })
    },
    updateDiffs({ state, getters, dispatch, commit }) {
      const date = state.dates[state.dates.indexOf(state.date) - 1] // new Date(state.date).getTime() - 24 * 60 * 60 * 1000
      if (state.date.includes('2020-12-30')) {
        return false
      }
      return dispatch('fetchData', date)
        .then(data => {
          if (!data) {
            return
          }
          const newPlayers = state.players
          const oldPlayers = data.players
          const newPlacements = getPlacementsById(newPlayers)
          const oldPlacements = getPlacementsById(oldPlayers)
          const oldPlayersById = {}
          for (const player of oldPlayers) {
            oldPlayersById[player.id] = player
          }
          for (const newPlayer of newPlayers) {
            const oldPlayer = oldPlayersById[newPlayer.id]
            if (oldPlayer) {
              for (const mode of getters.modes) {
                if (newPlayer[mode.id] && oldPlayer[mode.id]) {
                  newPlayer[mode.id].placementDiff = oldPlacements[mode.id][oldPlayer.id] - newPlacements[mode.id][newPlayer.id]
                  newPlayer[mode.id].ratingDiff = newPlayer[mode.id].rating - oldPlayer[mode.id].rating
                }
              }
            }
          }
          commit('update', { players: newPlayers })
        })
        .catch(err => {
          console.warn('Something went wrong', err)
        })
    },
    fetchStats({ state, getters, commit }, userId) {
      if (state.loadedStats[userId]) {
        return Promise.resolve(state.loadedStats[userId])
      }
      commit('addLoading')
      return fetch(`https://api.diabotical.com/api/v0/diabotical//users/${userId}/stats`)
        .then(res => res.json())
        .then(data => {
          const stats = {}
          const periodData = data.filter(item => item.time_frame === 'season')
          for (const mode of getters.modes) {
            const modeStats = periodData.filter(item => item.match_mm_mode === mode.newId)
            stats[mode.newId] = getWeaponStats(modeStats)
          }
          const modeStats = periodData.filter(item => item.match_mode === '')
          stats.all = getWeaponStats(modeStats)

          const loadedStats = { ...state.loadedStats, [userId]: stats }
          commit('update', { loadedStats })
        })
        .catch(() => {
          console.warn(`Can't load player stats`)
        })
        .finally(() => {
          commit('removeLoading')
        })
    },
    toggleStats({ dispatch, commit }, userId) {
      dispatch('fetchStats', userId).then(() => {
        commit('toggleStats', userId)
      })
    },
    sortBy({ commit }, sort) {
      commit('update', { sort })
      save({ sort })
      Vue.nextTick(() => {
        document.querySelector('.leaderboard').scrollTo(0, 0)
      })
    },
    stickPlayer({ state, commit }, id) {
      const sticked = [...state.sticked]
      const index = state.sticked.findIndex(item => item === id)
      if (index === -1) {
        sticked.push(id)
      } else {
        sticked.splice(index, 1)
      }
      commit('update', { sticked })
      save({ sticked })
    },
    test({ state, commit }) {
      const test = !state.test
      commit('update', { test })
      save({ test })
    },
  },
})

// TODO
// function resetBrokenSort() {
//   if (!store.state.modes.find(mode => mode.id === storage.sort) {
//       = 'r_duel.rating'
//   }
// }

function getWeaponStats(stats) {
  return store.state.weapons.map(weapon => {
    const item = stats.find(item => item.filter === weapon.id)
    return item && +item.shots_fired
      ? {
          shots: +item.shots_fired,
          hits: +item.shots_hit,
          frags: +item.frags,
          deaths: +item.deaths,
          percent: +item.shots_fired ? Math.round((100 * item.shots_hit) / item.shots_fired) : 0,
          kd: +item.deaths ? (Math.round((100 * item.frags) / item.deaths) / 100).toFixed(2) : item.frags,
        }
      : null
  })
}

export default store
